export enum FlowType {
  ADD_CARD = 'ADD_CARD',
  TOP_UP = 'TOP_UP',
  CHARGE_ADD_CARD = 'CHARGE_ADD_CARD',
}

export interface CardDetailsFormProps {
  amount: number;
  ContainerClassName?: string;
  flow: FlowType;
  portfolioId?: number;
  btnText?: string;
  onSuccessUrl?: string;
  onFailureUrl?: string;
  isUseExistingCard?: boolean;
  transactionType?: string;
}
